<template>
    <div class="futurebet-container">
    <div class="futurebet-info">
        <span class="futurebet-label" v-translate="'future_bet'"></span>
    </div>
    <div class="futurebet-boxes">
    <div class="futurebet-box"
             v-for="n in maxFutureRounds"
             :class="{is__active : n == bettingSvc.numEvents}"
             @click="setFutureRound(n)"
             :key="n">
              <div class="futurebet-number"> 
                {{n}} 
             </div>
        </div>
    </div>
    </div>
</template>

<script>

import { BettingSvc }   from '../../services/betting.service';
import { GameSvc } from '../../services/game.service';
import { Translate } from '../../directives/translate';

export default {
    name: "Futurebets",

    directives: {
        Translate
    },

    data() {
        return {
            bettingSvc : BettingSvc.getBettingSvc(),
            gameSvc : GameSvc.getGameSvc(),
        };
    },

    computed: {
        maxFutureRounds() {
            return this.bettingSvc.maxFutureRounds;
        }
    },

    methods: {
        setFutureRound(round) {
            this.bettingSvc.numEvents = parseInt(round, 10);
        },
    }
}

</script>

<style lang="scss">

.futurebet-container {

    width: 100%;

    .futurebet-info {

        border-left: 4px solid #0066ae;
        margin-bottom: 7px;
    
        .futurebet-label{
            width: 20%;
            color: #fff;
            margin-left: 10px;
            font-weight: bold;
        }
    }

    .futurebet-boxes {
        width: 100%;
        display: inline-flex;

        .futurebet-number{
          margin-top:15%;
        }
        
       .futurebet-box{
            width: 9%;
            height: 35px;
            cursor: pointer;
            margin-right: 5px;
            color: #e6e6e6;
            background-color: #424242;
            text-align: center;
            margin-bottom: 10px;
       }

         .is__active {
            background-color: #685834;
        }
    }



}

    
   
</style>


// WEBPACK FOOTER //
// FutureBets.vue?2f32df98